export const analytics = {
  title: "التحليلات",
  subtitle: "الإيرادات والإشغال لعقاراتك خلال الفترة التي تختارها.",
  tabs: {
    performance: "الأداء",
    channels: "القنوات",
  },
  allAccommodations: "جميع أماكن الإقامة",
  compare: {
    prevPeriod: "الفترة السابقة",
    prevYear: "العام السابق",
    titlePrevPeriod: "المقارنة: الفترة السابقة",
    titlePrevYear: "المقارنة: العام السابق",
    inlinePrevPeriod: "الفترة السابقة",
    inlinePrevYear: "العام السابق",
  },
  summary: {
    currentPeriod: "الفترة الحالية",
    paymentFilter: "تصفية الدفع",
  },
  presets: {
    today: "اليوم",
    yesterday: "أمس",
    d7: "7 أيام",
    d30: "30 يوماً",
    m3: "3 أشهر",
    m6: "6 أشهر",
    year: "سنة واحدة",
  },
  payment: {
    all: "جميع المدفوعات",
    pending: "قيد الانتظار",
    paid: "مدفوعة",
    rejected: "مرفوضة",
    refunded: "مُستردّة",
    partial: "دفع جزئي",
  },
  kpi: {
    totalRevenue: "إيرادات الفترة",
    arrivalRevenue: "إجمالي قيمة عمليات الوصول",
    revpar: "RevPAR",
    occupancyRate: "معدّل الإشغال",
    adr: "ADR",
    avgStay: "متوسط مدة الإقامة",
    bookingWindow: "نافذة الحجز",
  },
  units: {
    days: " يوم",
  },
  chart: {
    thisPeriod: "هذه الفترة",
    subtitle: "{current} · مقارنةً بـ {compared} · {payment}",
  },
  channels: {
    directBookings: "الحجوزات المباشرة",
    otaBookings: "حجوزات OTA",
    bookingDetails: "تفاصيل الحجز",
    byChannel: "حسب القناة",
    tableChannel: "القناة",
    tableRevenue: "الإيرادات",
    direct: "المباشرة",
    ota: "OTA",
    noData: "لا توجد بيانات للفترة المحددة",
  },
  a11y: {
    chartOf: "رسم بياني لـ {label}",
    directVsOta: "رسم بياني للحجوزات المباشرة مقابل OTA",
  },
};
